import {useState} from 'react';
import PropTypes from 'prop-types';
import {groupShape} from '../shapes';

export default function NewTemplateModal({groups, onConfirm, onCancel}) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [groupId, setGroupId] = useState('');

    function submit() {
        const n = name.trim();
        if (!n) return;
        onConfirm(n, description.trim(), groupId || null);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') submit();
        if (e.key === 'Escape') onCancel();
    }

    return (
        <div
            className="modal-backdrop"
            onClick={onCancel}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            role="presentation"
        >
            <div
                className="modal"
                onClick={e => e.stopPropagation()}
                onKeyDown={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="modal-title">New Template</h3>
                <input
                    className="modal-input"
                    type="text"
                    placeholder="Template name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />
                <input
                    className="modal-input"
                    type="text"
                    placeholder="Description (optional)"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                {groups && groups.length > 0 && (
                    <select
                        className="modal-input"
                        value={groupId}
                        onChange={e => setGroupId(e.target.value)}
                    >
                        <option value="">No group</option>
                        {groups.map(g => (
                            <option key={g.id} value={g.id}>{g.name}</option>
                        ))}
                    </select>
                )}
                <div className="modal-actions">
                    <button className="modal-cancel" onClick={onCancel}>Cancel</button>
                    <button className="modal-confirm" onClick={submit} disabled={!name.trim()}>Create</button>
                </div>
            </div>
        </div>
    );
}

NewTemplateModal.propTypes = {
    groups: PropTypes.arrayOf(groupShape),
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
